/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { AppDeploymentRepresentation } from '../model/appDeploymentRepresentation';
import { ResultListDataRepresentationAppDeploymentRepresentation } from '../model/resultListDataRepresentationAppDeploymentRepresentation';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class RuntimeAppDeploymentsApi extends BaseApi {
    deleteAppDeployment(appDeploymentId) {
        throwIfNotDefined(appDeploymentId, 'appDeploymentId');
        const pathParams = {
            appDeploymentId
        };
        return this.delete({
            path: '/api/enterprise/runtime-app-deployments/{appDeploymentId}',
            pathParams
        });
    }
    exportAppDefinition(deploymentId) {
        throwIfNotDefined(deploymentId, 'deploymentId');
        const pathParams = {
            deploymentId
        };
        const accepts = ['application/zip'];
        return this.get({
            path: '/api/enterprise/export-app-deployment/{deploymentId}',
            pathParams,
            accepts
        });
    }
    getAppDefinitions(opts) {
        return this.get({
            path: '/api/enterprise/runtime-app-deployments',
            queryParams: opts,
            returnType: ResultListDataRepresentationAppDeploymentRepresentation
        });
    }
    getAppDeployment(appDeploymentId) {
        throwIfNotDefined(appDeploymentId, 'appDeploymentId');
        const pathParams = {
            appDeploymentId
        };
        return this.get({
            path: '/api/enterprise/runtime-app-deployments/{appDeploymentId}',
            pathParams,
            returnType: AppDeploymentRepresentation
        });
    }
    getRuntimeAppDeploymentByDeployment(opts) {
        return this.get({
            path: '/api/enterprise/runtime-app-deployment',
            queryParams: opts,
            returnType: AppDeploymentRepresentation
        });
    }
}
